import React, { Component } from 'react';
import Formulario from './IngresoCajasForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class IngresoCajas extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo,leerPeriodoD, 
        vaciar, numeroIngreso } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5], periodo[4]);
        numeroIngreso();
        vaciar();
        
        localStorage.removeItem('id_detalle_ingreso_cajas');
    }
    
    render(){
        const { loader, modulo, periodoD, listarInsumos, registroIngreso, 
            detalleInsumo, detallePro, listarClientes, eliminarLineaInsumo,
            nuevaLineaInsumo, listarPilotos, numeroS, numeroIngreso, lectura,
            listarFases, agregarLinea, modificarIngreso, eliminarLinea,
            numeroIng } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    periodoD = {periodoD}
                    detalleCon = {detallePro}
                    registroIngreso = {registroIngreso}
                    modificarIngreso = {modificarIngreso}
                    listarInsumos = {listarInsumos}
                    detalleInsumo = {detalleInsumo}
                    numeroS = {numeroS}
                    listarFases = {listarFases}
                    agregarLinea = {agregarLinea}
                    listarPilotos = {listarPilotos}
                    listarClientes = {listarClientes}
                    eliminarLinea = {eliminarLinea}
                    nuevaLineaInsumo = {nuevaLineaInsumo}
                    eliminarLineaInsumo = {eliminarLineaInsumo}
                    numeroIngreso = {numeroIngreso}
                    lectura = {lectura}
                    numeroIng = {numeroIng}
                />
            </LoadMask>
        );
    }
}

export default IngresoCajas
